import Vue from 'vue'
// 混入
Vue.mixin({
    data(){
        return{
          mall: '商城',
          userToken:localStorage.getItem('accessToken')?localStorage.getItem('accessToken'):'',
          headPortrait:require("@/assets/images/Pikachu.jpg"),
          logo:require("@/assets/images/Pikachu.jpg"),
          loginType: localStorage.getItem('loginType'),
          deviceNum:localStorage.getItem('deviceNum'),
          userInfo:localStorage.getItem('userInfo')?JSON.parse(localStorage.getItem('userInfo')):{},
        }
    },
    beforeDestroy() {

    },
    methods:{

    }
})
